module.exports = __webpack_public_path__ + "img/Logo.2d56568a.png";